import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

export interface EeDrawerProps {
  open: boolean;
  anchor?: 'left' | 'right';
  onOpen?: () => void;
  onClose?: () => void;
  children?: React.ReactNode;
}

export const EeDrawer: React.FC<EeDrawerProps> = ({
  open = false,
  anchor = 'right',
  onClose,
  children,
}) => {
  return (
    <Drawer anchor={anchor} open={open} onClose={onClose}>
      <>
        <div className="d-flex">
          <IconButton aria-label="cancel" className="ml-auto" onClick={onClose}>
            <CancelOutlinedIcon />
          </IconButton>
        </div>
        {children}
      </>
    </Drawer>
  );
};
